// Generated by i18nline.
import I18n from 'i18nline';

I18n.supportedLocales = ['de','en','fr','it'];
I18n.defaultLocale = 'en';

I18n.import = locale => {
	// we use a switch here so the import statements are statically
	// analyzable. the use of import() will make build tools generate
	// separate bundles which are downloaded on-demand.
	switch (locale) {
		case 'de': return import(/* webpackChunkName: 'i18n.de' */ './de.json');
		case 'en': return import(/* webpackChunkName: 'i18n.en' */ './en.json');
		case 'fr': return import(/* webpackChunkName: 'i18n.fr' */ './fr.json');
		case 'it': return import(/* webpackChunkName: 'i18n.it' */ './it.json');
		default: return import(/* webpackChunkName: 'i18n.default' */ './default.json');
	}
};

if ((typeof module === 'object') && module.hot) {
	module.hot.accept('./de.json', I18n.reload('de'));
	module.hot.accept('./en.json', I18n.reload('en'));
	module.hot.accept('./fr.json', I18n.reload('fr'));
	module.hot.accept('./it.json', I18n.reload('it'));
	module.hot.accept('./default.json', I18n.reload('default'));
}

export default I18n;
